import { SET_USERS } from "../types/usersManagementTypes";

const initialState = {
  all: [],
  selected: null,
  totalPages: 0,
  organizations: [],
};

const usersManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USERS:
      return {
        ...state,
        all: action.payload.users,
        totalPages: action.payload.total_pages,
        organizations: action.payload.organizations,
      };
    default:
      return state;
  }
};

export default usersManagementReducer;
